/*
 *   File : set-pin.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - Set Pin page
 *   Integrations : js-cookie,react-toastify
 *   Version : 1.0.0
 *   Date : 22-09-2022  
*/

import { useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"

//custom components
import { OTPInput } from "../../../Component/Form-Elements";
import { PrimaryButton } from "../../../Component/Buttons";
import { Icon } from "../../../Component/Icon"
import { KycStatusModal } from "../../../Component/Modal";
import { APIService } from "../../../Service";

//custom styles
import styles from "../../../Style/Component/login.module.scss";
import Colors from "../../../Style/color.scss";
import Store from "../../../Store/store";
import { AuthSlider } from "../../../Component/Banner";
import { _getProfile } from "../../../Helper";


const ONBOARDING_SLIDES = [
    {
        image: require("../../../Assets/Images/Onboarding/slides/partner-ship.webp"),
        heading: "A Partnership You Can Trust",
        description: "A promise of secure systems, regulated platforms, and trustworthy investments."
    },
    {
        image: require("../../../Assets/Images/Onboarding/slides/vision.webp"),
        heading: "A Vision That Inspires",
        description: "Guided by strong values and trust, index funds empower every investor’s journey."
    },
    {
        image: require("../../../Assets/Images/Onboarding/slides/smart-fund-allocation.webp"),
        heading: "Smart Fund Allocation",
        description: "Make informed choices with secure, diversified, and high-return investment options."
    },
    {
        image: require("../../../Assets/Images/Onboarding/slides/invest-top-indices.webp"),
        heading: "Invest in India’s Top Indices",
        description: "Secure, transparent, and diversified index fund investments at your fingertips."
    },
];




const SetPIN = (props) => {


    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const inputPINRef = useRef(null); // Enter PIN
    const confirmPINRef = useRef(null); // Re-Enter PIN
    const [focusedInputNew, setFocusedInputNew] = useState(2);
    const [focusedInputConfirm, setFocusedInputConfirm] = useState(0);
    const [newPinValue, setNewPinValue] = useState("");
    const [confirmNewPinValue, setConfirmNewPinValue] = useState("");
    const [pinError, setPinError] = useState("");
    const [statusModal, setStatusModal] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });
    }, []);

    // handling Enter key 
    useEffect(() => {

        const _handleOnEnter = (e) => {
            if (e.key === 'Enter') {
                if (loading === false) {
                    _handleVerifyPin();
                }
            }
        };

        document.addEventListener('keydown', _handleOnEnter);

        return () => {
            document.removeEventListener('keydown', _handleOnEnter);
        };

    }, [newPinValue, confirmNewPinValue, loading]);

    useEffect(() => {
        if (statusModal === true) {
            let kyc_status = new Modal(document.getElementById('kyc-status-modal'));
            kyc_status.show();
        }
    }, [statusModal]);

    //handle new pin
    const _handleNewPin = (value) => {
        setNewPinValue(value);
        if (value.length == 4) {
            setFocusedInputConfirm(2);
            inputPINRef.current.blur();
        }
    };

    //handle confirm new pin
    const _handleConfirmNewPin = (value) => {
        setConfirmNewPinValue(value);
    };

    // create account pin
    const _handleVerifyPin = () => {
        if (newPinValue !== confirmNewPinValue) {
            setPinError("PIN does not match");
            setLoading(false);
        } else {
            setPinError("");
            setLoading(true);
            //    API Call
            _setPIN();
        }
    };

    // handle back  
    const _handleBackToPreviousStep = () => {
        sessionStorage.removeItem('access_token');
        Cookies.remove('onboarding_refresh_token', { domain: process.env.REACT_APP_DOMAIN, path: '/', expires: 30 });
        Store.dispatch({
            type: 'UPDATE_ONBOARDING_TOKEN',
            payload:
                { refresh_token: null, access_token: null }
        });
        // enable navigation to Home page
        navigate("/", { replace: true, });
    };
    // Switch onboarding session to a logged-in session and open the onboarding invest page
    const _handleNavigateToOnboardingInvest = () => {

        let refresh_token = Cookies.get("onboarding_refresh_token");
        Cookies.remove("onboarding_refresh_token");
        Cookies.set("refresh_token", refresh_token, {
            domain: process.env.REACT_APP_DOMAIN,
            path: "/",
            expires: 30,
        });

        Store.dispatch({
            type: "UPDATE_REFRESH_TOKEN",
            payload: refresh_token,
        });

        Store.dispatch({
            type: "UPDATE_ONBOARDING_TOKEN",
            payload: { refresh_token: null, access_token: null },
        });

        // enable navigation to Onboarding Invest page
        // Timeout to schedule navigation after store updates
        setTimeout(() => {
            navigate("/invest", { replace: true });
        }, 0);

        // Update user data in redux
        _getProfile();
    };

    // handle modal close
    const _handleModalClose = () => {
        // Closing modal
        var button = document.getElementById("kyc-status-modal-close-btn");
        button.click();

        setStatusModal(false);

        if (props.kycUser) {
            _handleNavigateToOnboardingInvest();
        } else {
            sessionStorage.removeItem('access_token');
            Cookies.remove('onboarding_refresh_token', { domain: process.env.REACT_APP_DOMAIN, path: '/', expires: 30 });
            Store.dispatch({
                type: 'UPDATE_ONBOARDING_TOKEN',
                payload:
                    { refresh_token: null, access_token: null }
            });
            // enable navigation to Home page
            navigate("/", { replace: true, });
        }
    };





    // ================================ //
    //============= API CALLS ========= //

    // API - get sign-in otp
    const _setPIN = () => {

        let api_version = 2;
        let is_post = true;
        let url = 'auth/set-pin';
        let data = {
            "pin": confirmNewPinValue
        };
        let token = sessionStorage.getItem('access_token');

        APIService(is_post, url, data, token, api_version).then((response) => {
            if (response.status_code === 200) {
                setStatusModal(true);
                // Removing Set Pin check
                localStorage.setItem("is_auth_configured", false);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };

    return (

        <>

            <div className="col-sm-10 col-md-9 col-lg-8 col-xl-7 mx-auto px-md-0">
                <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                    <div className={`${styles.e_onboarding_wrapper} e-border-radius-24`}>
                        <div className="row justify-content-between align-items-center">
                            <AuthSlider key={"set-pin-slider"} />
                            <div className="col-md-6  col-12 position-relative gradient-vr-line">
                                <div className="margin-32px-right no-margin-res">
                                    <Icon icon="arrow-back-left"
                                        className="cursor-pointer mb-sm-3"
                                        size={24}
                                        color={Colors.charleston_green}
                                        onClick={_handleBackToPreviousStep} />

                                    <h2 className="text-gradient-primary e-alt-font-poppins e-font-weight-600 e-font-18-res e-font-24 line-height-32px letter-spacing-neg-2per mb-1">
                                        Create Your Security Pin
                                    </h2>

                                    <p className="e-text-onyx-80per e-alt-font-poppins e-font-weight-400 e-font-14-res e-font-16 line-height-24px">
                                        Set your 4 digit pin and get started.
                                    </p>
                                    <OTPInput id="newPin"
                                        label="Set new 4 digit PIN*"
                                        ref={inputPINRef}
                                        value={newPinValue}
                                        spellcheck="false"
                                        focused_input={focusedInputNew}
                                        onFocus={() => setFocusedInputNew(2)}
                                        onBlur={() => setFocusedInputNew(0)}
                                        onChange={_handleNewPin} />
                                    <div className="pt-1">
                                        <OTPInput
                                            id="confirmNewPin"
                                            label="Confirm 4 digit PIN*"
                                            ref={confirmPINRef}
                                            value={confirmNewPinValue}
                                            spellcheck="false"
                                            focused_input={focusedInputConfirm}
                                            error={pinError}
                                            onFocus={() => setFocusedInputConfirm(2)}
                                            onBlur={() => setFocusedInputConfirm(0)}
                                            onChange={_handleConfirmNewPin} />
                                    </div>

                                    <div className="mt-4">
                                        <PrimaryButton
                                            name="Continue"
                                            className={`w-100 padding-12px-tb e-font-14`}
                                            loading={loading}
                                            disabled={loading}
                                            inActive={newPinValue.length === 4 && confirmNewPinValue.length === 4 ? false : true}
                                            onPress={_handleVerifyPin}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* kyc status modal  */}
            {
                statusModal === true &&
                <KycStatusModal title={props.isNRI ? "Submitted" : "Account created!"}
                    image={require("../../../Assets/Images/KYC/kyc-success.webp")}
                    description={props.kycUser === false ? "The account creation process has been initiated and the process will take 1-3 business days time. We will notify over mail once it is completed." :
                        "Your account has been created successfully. You can start investing anytime."}
                    onCloseModal={_handleModalClose}
                    buttonName={props.isNRI ? "Start Investing" : props.kycUser ? "Continue" : "Understood"}
                    onButtonClick={_handleModalClose}
                />
            }
        </>
    )
}
export default SetPIN;